import React from 'react';
import { useTheme } from 'styled-components';
import { IconProps } from 'components/icons/types';

export const UserWalletIcon = ({ className }: IconProps) => {
  const theme = useTheme();

  return (
    <svg
      viewBox="0 0 61 60"
      className={className}
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="2" width="58" height="58" rx="29" fill={theme.w.colors.primary.main} />
      <path
        d="M41.4835 18.9287H18.6825C17.971 18.9287 17.2887 19.2113 16.7857 19.7144C16.2826 20.2175 16 20.8997 16 21.6112V40.3885C16 41.0999 16.2826 41.7822 16.7857 42.2853C17.2887 42.7883 17.971 43.071 18.6825 43.071H40.1423C40.8537 43.071 41.536 42.7883 42.0391 42.2853C42.5421 41.7822 42.8247 41.0999 42.8247 40.3885V25.6349C42.8247 25.2792 42.6834 24.938 42.4319 24.6865C42.1804 24.435 41.8392 24.2937 41.4835 24.2937H20.0237C19.668 24.2937 19.3268 24.1523 19.0753 23.9008C18.8238 23.6493 18.6825 23.3081 18.6825 22.9524C18.6825 22.5967 18.8238 22.2556 19.0753 22.004C19.3268 21.7525 19.668 21.6112 20.0237 21.6112H42.8247V20.2699C42.8247 19.9142 42.6834 19.5731 42.4319 19.3215C42.1804 19.07 41.8392 18.9287 41.4835 18.9287ZM38.1304 31.6705C38.5283 31.6705 38.9173 31.7884 39.2481 32.0095C39.579 32.2306 39.8368 32.5448 39.9891 32.9124C40.1414 33.28 40.1812 33.6845 40.1036 34.0748C40.026 34.4651 39.8344 34.8235 39.553 35.1049C39.2716 35.3863 38.9132 35.5779 38.5229 35.6555C38.1326 35.7331 37.7281 35.6933 37.3605 35.541C36.9929 35.3888 36.6787 35.1309 36.4576 34.8C36.2365 34.4692 36.1185 34.0802 36.1185 33.6823C36.1185 33.1487 36.3305 32.637 36.7078 32.2597C37.0851 31.8824 37.5968 31.6705 38.1304 31.6705Z"
        fill={theme.w.colors.button.text}
      />
      <circle cx="50.5" cy="10" r="10" fill="#242C3C" />
      <circle cx="50.5" cy="10" r="8" fill="currentColor" />
      <path
        d="M53.9117 11.596C53.3447 11.1168 53.0195 10.4163 53.0195 9.67416V8.62866C53.0195 7.30904 52.0393 6.21666 50.7695 6.03366V5.62866C50.7695 5.42129 50.6015 5.25366 50.3945 5.25366C50.1875 5.25366 50.0195 5.42129 50.0195 5.62866V6.03366C48.7494 6.21666 47.7695 7.30904 47.7695 8.62866V9.67416C47.7695 10.4163 47.4444 11.1168 46.874 11.599C46.7282 11.7239 46.6445 11.9054 46.6445 12.0974C46.6445 12.4593 46.9389 12.7537 47.3008 12.7537H53.4883C53.8502 12.7537 54.1445 12.4593 54.1445 12.0974C54.1445 11.9054 54.0609 11.7239 53.9117 11.596Z"
        fill={theme.w.colors.button.text}
      />
      <path
        d="M50.3953 14.2537C51.0745 14.2537 51.6426 13.7695 51.7731 13.1287H49.0176C49.1481 13.7695 49.7162 14.2537 50.3953 14.2537Z"
        fill={theme.w.colors.button.text}
      />
    </svg>
  );
};
